function calculateinstallmentTotal() {
  const installmentData = getPaymentOptionsStorage()

  if (installmentData === null) {
    console.log('ERROR')
    return 0
  }

  let totalAmounts = Object.values(installmentData).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.cash_source_amount)
  }, 0)

  return totalAmounts
}

$(document).ready(function () {

  if ($('#customer-payment-form').length > 0) {
    console.log('B')
    $('#submit-ajax-form-btn').click(function () {
      disableSubmit()

      let errorString = [];

      if (isEmpty($('#payment-transaction-date').val())) {
        errorString.push(' Transaction date cannot be blank');
      }

      const paymentOptions = getPaymentOptionsStorage()

      if (paymentOptions === null ||
        paymentOptions === undefined ||
        (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
        errorString.push('Payment option amount not set')
      }

      if (errorString.length > 0) {
        toastNotification('error', errorString.join(','))
      } else {
        $('#spinner-modal').modal('show');

        const revenueId = $('#customer-payment-form').data('revenue-id')
        const postUrl = $('#customer-payment-form').attr('action')
        const paymentOptions = getPaymentOptionsStorage()
        const dateReceived = $('#customer-payment-form input[name="customer_payment[date_received]"]').val()
        const description = $('#customer-payment-form input[name="customer_payment[description]"]').val()
        const customerId = $(`select[name="customer_payment[customer_id]"] option:selected`).val()
        const redirectUrl = `/customer_payments?customer_id=${customerId}&revenue_id=${revenueId}`
        const branchId = $('#customer-payment-form input[name="customer_payment[branch_id]"]').val()
        const totalAmount = calculateinstallmentTotal()
        console.log(totalAmount)

        let action = "post"

        if ($('#customer-payment-form input[name="customer_payment[payment_action]"').val() === 'update') {
          action = "patch"
        }

        $.ajax({
          type: action,
          url: postUrl,
          headers: {
            'X-CSRF-Token': csrfToken()
          },
          data: {
            payment_options: paymentOptions,
            customer_payment: {
              date_received: dateReceived,
              revenue_id: revenueId,
              description: description,
              amount: totalAmount,
              customer_id: customerId,
              branch_id: branchId
            }
          },
          dataType: "json",
          success: function (data) {
            removePaymentOptionData()
            window.location.replace(redirectUrl)
            console.log(data)
          },
          error: function (data) {
            clearDisabledSubmit()
            console.log('An error occurred.');
            console.log(data);
          },
        });
      }
    });

    clearFailedSubmit('#customer-payment-form')
  }
});
